import {
    isCodeListValid,
    ScanCodeListDefinition,
    ScannedCode,
    ScannedCodeType,
    scannedCodeTypes,
} from 'app/features/scan-flow/models';
import { Activity, ActivityType } from 'app/shared/features/activity-selector/models';
import { MeasurementType } from 'app/shared/models';
import { isAmountResultProvided, isAmountResultValidOrEmpty } from 'app/shared/utils';
import {
    areProductBoxRegistrationsValidOrEmpty,
    filterByCodeType,
    getFirstByCodeType,
} from 'app/state/scan-flow/scan-flow.utils';

function isPackingActivity(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.activityType === ActivityType.Packing;
}

export function isContainerMeasurementWeight(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerWeight;
}

export function isContainerMeasurementProductBoxes(activity: Activity | undefined) {
    if (!activity) return false;
    return activity.measurementType === MeasurementType.containerProductBoxes;
}
// container measurement activity is a packing activity with measurement type
export function isResultRegistrationActivity(activity: Activity | undefined) {
    return (
        isPackingActivity(activity) &&
        (isContainerMeasurementWeight(activity) || isContainerMeasurementProductBoxes(activity))
    );
}

export function isContainerMeasurementRegistrationDataComplete(
    employeeNumber: number | undefined,
    scanCodeListDefinitions: ScanCodeListDefinition[],
    scannedCodes: ScannedCode[],
    activity: Activity | undefined,
    amountResult: number | undefined,
    productBoxRegistrations: any[],
) {
    // Only for container measurement activities, we want to ensure all codes are scanned to ensure data completeness.
    return (
        !!employeeNumber &&
        !!scanCodeListDefinitions.length &&
        scannedCodeTypes.every((codeType: ScannedCodeType) => {
            const listDefinition = getFirstByCodeType(scanCodeListDefinitions, codeType);
            const scannedCodesByCodeType = filterByCodeType(scannedCodes, codeType);
            return (
                (!listDefinition && !scannedCodesByCodeType.length) ||
                (!!listDefinition && isCodeListValid(listDefinition, scannedCodesByCodeType))
            );
        }) &&
        isContainerMeasurementWeight(activity) === isAmountResultProvided(amountResult) &&
        isAmountResultValidOrEmpty({ amountResult, activity }) &&
        isContainerMeasurementProductBoxes(activity) === !!productBoxRegistrations.length &&
        areProductBoxRegistrationsValidOrEmpty(productBoxRegistrations, activity)
    );
}
